import { render, staticRenderFns } from "./shopCard.vue?vue&type=template&id=5b4eb152&scoped=true"
import script from "./shopCard.vue?vue&type=script&lang=js"
export * from "./shopCard.vue?vue&type=script&lang=js"
import style0 from "./shopCard.vue?vue&type=style&index=0&id=5b4eb152&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4eb152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\mam\\home\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4eb152')) {
      api.createRecord('5b4eb152', component.options)
    } else {
      api.reload('5b4eb152', component.options)
    }
    module.hot.accept("./shopCard.vue?vue&type=template&id=5b4eb152&scoped=true", function () {
      api.rerender('5b4eb152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/shopCard.vue"
export default component.exports